<template>
  <ListView
    modelName="PurchaseDelivery"
    perm="purchase.menu_purchase_delivery"   
    svg="icon_side_arrival" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_purchase_delivery"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="PurchaseDelivery"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    @selected="onSelectedMain"
    :isLoading="isLoading"
    borderColor="#4099DA"
    backColor="#E5F4FF"    
    tourId="291621"
    :comparer="(a,b)=>a.deliveryNo == b.deliveryNo"        
    :postAddHandler="submitBundleAddDeliveryItemRun"                 
    :popup="popup"                 
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseDeliveryStatus2"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.deliveryNo }}</GridItem>
    <GridItem :slot="listSlots[2]" slot-scope="{ item, index }"><Workflow :item="item" :index="index" @updated="onWorkflow" :perm="$refs.mainList.perm+'.approve'"/></GridItem>    
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.bookDate | date }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.counterpart.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.deliveryFlag | deliveryFlagsHasServices }}</GridItem>    
    <!-- <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.scheduledDeliveryDate | date }}</GridItem> -->
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.deliveryDate | date }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }">{{ item.warehouse?item.warehouse.name:'' }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.receiver?item.receiver.name:'' }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.refNo }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.isTransitPost | transitTypes }}</GridItem>    
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.currencyCode | currency }}</GridItem>
    <GridItem :slot="listSlots[12]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.currencyCode) }}</GridItem>    
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ ( item.counterpart ? item.counterpart.taxType : null ) | taxTypes }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.exchangeRate | numeric}}</GridItem>
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.projectItem?item.projectItem.name:'' }}</GridItem>      
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.segmentId | segment }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.pic | user }}</GridItem>
    <!-- <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.closingDate | date }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.dueDate | date }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.amountFC }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.taxAmountFC }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.totalAmountFC }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[22]" slot-scope="{ item }">{{ item.currentAmountFC }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[23]" slot-scope="{ item }">{{ item.amount }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[24]" slot-scope="{ item }">{{ item.taxAmount }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[25]" slot-scope="{ item }">{{ item.totalAmount }}</GridItem>     -->
    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }">{{ item.lastUpdatedBy | user }}</GridItem>

    <!-- リストメニューの配置 -->
    <template slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :electronicBookMode="tenantSettings.electronicBookMode" :getKeyValue="(obj)=>obj.deliveryNo" >
        <!-- <ListViewMenu title="支払処理" @click="showDeliveryPaymentDialog" /> -->
      </ListViewMenuBar>
    </template>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="['検索条件','取引先区分','予備項目']">
        <FilterBox title="入荷番号" :value.sync="params.deliveryNo" @click="handler" />
        <FilterBox title="入荷管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="発注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />
        <FilterBox title="仕入先名称" :value.sync="params.counterpartName" @click="handler"/>
        <ComboBox title="計上区分" :value.sync="params.isTransitPost" list="transitTypes" @changed="handler" />               
        <AtcCounterpart title="仕入先" :value.sync="params.counterpart" :needsSupplier="true" @changed="handler" />
        <AtcCounterpart title="入庫倉庫" :value.sync="params.warehouse" :needsWarehouse="true" @changed="handler" />
        <AtcProjectItem title="案件" :value.sync="params.projectItem" @changed="handler"/>           
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />        
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />                  
        <!-- <Calendar title="入荷予定日(From)" :value.sync="params.scheduledDeliveryDateFrom" :deletable="true" @changed="handler" /> -->
        <!-- <Calendar title="入荷予定日(To)" :value.sync="params.scheduledDeliveryDateTo" :deletable="true" @changed="handler" /> -->
        <Calendar title="仕入日(From)" :value.sync="params.bookDateFrom" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.bookDateFromFlag"/>
        <Calendar title="仕入日(To)" :value.sync="params.bookDateTo" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.bookDateToFlag"/>        
        <Calendar title="入荷日(From)" :value.sync="params.deliveryDateFrom" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.deliveryDateFromFlag"/>
        <Calendar title="入荷日(To)" :value.sync="params.deliveryDateTo" :deletable="true" @changed="handler" :autoEntry="true" :dateFlag.sync="params.deliveryDateToFlag"/>
        <FilterBox title="入荷金額(From)" :value.sync="params.dealAmountFcFrom" :isNumber="true" @click="handler" />
        <FilterBox title="入荷金額(To)" :value.sync="params.dealAmountFcTo" :isNumber="true" @click="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
       <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />        
        <ComboBox title="状態" :value.sync="params.state" list="purchaseDeliveryStatus" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->
        <ComboBox slot="tab1" title="category_1" :value.sync="params.category1" list="category_1" @changed="handler" />
        <ComboBox slot="tab1" title="category_2" :value.sync="params.category2" list="category_2" @changed="handler" />
        <ComboBox slot="tab1" title="category_3" :value.sync="params.category3" list="category_3" @changed="handler" />
        <ComboBox slot="tab1" title="category_4" :value.sync="params.category4" list="category_4" @changed="handler" />
        <ComboBox slot="tab1" title="category_5" :value.sync="params.category5" list="category_5" @changed="handler" />
        <ComboBox slot="tab1" title="category_6" :value.sync="params.category6" list="category_6" @changed="handler" />

        <FilterBox slot="tab2" title="voucher_text1" :value.sync="params.reserveText1" @click="handler"   />
        <FilterBox slot="tab2" title="voucher_text2" :value.sync="params.reserveText2" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text3" :value.sync="params.reserveText3" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text4" :value.sync="params.reserveText4" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text5" :value.sync="params.reserveText5" @click="handler" />
        <FilterBox slot="tab2" title="voucher_text6" :value.sync="params.reserveText6" @click="handler" />
        <ComboBox slot="tab2" title="voucher_list1" :value.sync="params.reserveList1" list="category_31" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list2" :value.sync="params.reserveList2" list="category_32" @changed="handler" />
        <ComboBox slot="tab2" title="voucher_list3" :value.sync="params.reserveList3" list="category_33" @changed="handler" />         
        <Calendar slot="tab2" title="voucher_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" />
        <Calendar slot="tab2" title="voucher_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler"/>
        <Calendar slot="tab2" title="voucher_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" />     
        <FilterBox slot="tab2" title="voucher_memo1" :value.sync="params.reserveMemo1" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo2" :value.sync="params.reserveMemo2" @click="handler"/>
        <FilterBox slot="tab2" title="voucher_memo3" :value.sync="params.reserveMemo3" @click="handler"/> 
      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','入荷明細','記載事項','納入先詳細','予備項目','ワークフロー','更新履歴','添付ファイル']" :tabVisibles="listView.isInsertMode ? tabVisiblesOnInsert: tabVisibles"  :tabTooltips="[null,'入荷番号に紐づいている【入荷明細】を確認することができます。','任意に入荷データに関わる詳細情報を編集できるタブです。','納入先の情報が編集できます。【納入区分】が【直送】の場合は商品の出荷先、【在庫】の場合は入庫する倉庫の情報が表示されます。','任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【取引先予備項目】から変更が可能です。内容は帳票に載せることができます。',null,null,null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item, editor}">
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">               
            <Button class="button" @click="showPurchaseDeliveryItem" caption="明細表示" :disabled="editor.isEdit || disabledShowItemButton" icon="arrow_downward" tooltip="選択した入荷に紐づいている【入荷明細】の一覧を表示します。"/>
            <!-- <Button class="button" @click="showBundleAddDeliveryItemDialog" caption="明細追加" :disabled="editor.isEdit || disabledAddItemButton(item) || item.isTransitPost" icon="add" tooltip="選択した入荷に紐づく【入荷明細】の登録を行います。"/> -->
          </SplitButton>
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <TextBox title="入荷番号" :value="item.deliveryNo" :editor="editor" :enabled="false" tooltip="先頭に”PD”がつく番号が初回保存時に自動で付与されます。この番号は手動で変更することができません。"/>
              <Calendar title="仕入日" :value.sync="item.bookDate" :editor="editor" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, false) && isEditable2(item,true)" @update:value="onChangeBookDate(item, editor)" v-if="item.isTransitPost" tooltip="未着品処理で仕入日に設定した日付が表示されます。商品が入荷した日ではなく買掛金が発生する日付です。【計上区分】が【未着品計上】の場合のみ表示されます。"/>
              <AtcCounterpart title="仕入先" :value.sync="item.counterpart" :editor="editor" :needsSupplier="true" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, false) && isEditable2(item,true)" @update:value="onChangeSupplier(item, editor)" tooltip="商品を仕入れた取引先です。【取引先一覧】の【取引先種別】が【仕入先】になっているデータが選択できます。"/>
              <TextBox title="納入区分" :value="item.deliveryFlag | deliveryFlagsHasServices" v-if="item.deliveryFlag==DeliveryFlags.Direct" :editor="editor" :enabled="false" tooltip="入荷した商品を在庫とするか、お客様に直送するかの区分が表示されます。"/>
              <RadioButton title="納入区分" :value.sync="item.deliveryFlag" :list="$api.useStockFunction ? 'deliveryFlagsNoDirect' : 'deliveryFlagsNoDirectNoStock'"  v-if="item.deliveryFlag!=DeliveryFlags.Direct" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, true)" :isDirectEditEnabled="false" @update:value="onChangeDeliveryFlag(item)" tooltip="入荷した商品を在庫とするか、お客様に直送するかの区分が表示されます。"/>
              <AtcCounterpart title="入庫倉庫" :value.sync="item.warehouse" :editor="editor" :needsWarehouse="true" :enabled="isEditable(item.state, item.deliveryFlag, true, true, true)&&item.deliveryFlag==DeliveryFlags.Stock" :isDirectEditEnabled="false"  @update:value="onChangeWarehouse(item, editor)"  :required="item.deliveryFlag==DeliveryFlags.Stock" :key="1" tooltip="商品の入荷時に保管する倉庫を選択します。【取引先一覧】の【取引先種別】が【倉庫】になっているデータが選択できます。"/>
              <AtcCounterpart title="納入先" :value.sync="item.receiver" :editor="editor" :needsCustomer="true" :needsReceiver="true" :enabled="isEditable(item.state, item.deliveryFlag, true, false)" :isDirectEditEnabled="false" @update:value="onChangeReceiver(item, editor)"  v-if="item.deliveryFlag == DeliveryFlags.Direct" :key="2" tooltip="【納入区分】が【直送】の時に、発注した商品を送付する相手先を選択します。【取引先一覧】の【取引先種別】が【納入先】になっているデータが選択できます。"/>
              <!-- <Calendar title="入荷予定日" :value.sync="item.scheduledDeliveryDate" :editor="editor" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, true)" /> -->
              <Calendar title="入荷日" :value.sync="item.deliveryDate" :editor="editor" :required="true" :min="deliveryDateMin(item)" :enabled="isEditable(item.state, item.deliveryFlag, false, true, true)" :isDirectEditEnabled="false" @update:value="onChangeDeliveryDate(item, editor)" tooltip="商品が入荷した日付です。【在庫区分】が【在庫】の場合は倉庫に入荷した日付、【直送】の場合は出荷先に商品が到着した日付になります。"/>              
              <TextBox title="入荷管理番号" :value.sync="item.refNo" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="30" tooltip="任意で入荷に対して管理番号を入力することができます。"/>        
                <TextBox title="計上区分" :value="item.isTransitPost | transitTypes" :enabled="false" tooltip="仕入計上の区分である【仕入計上】【未着品計上】が表示されます。新規では【仕入計上】のみ作成でき、【未着品計上】は【発注一覧】または【発注明細一覧】から作成できます。"/>
                <TextBox title="仕入伝票" :value="item.deliveryNo" :editor="editor" :enabled="false" linkFormat="/purchase/PurchaseInvoice?invoiceNo={0}" v-if="isInvoiceVisible(item)" tooltip="選択した入荷に対応する仕入計上伝票番号が表示されます。入荷のワークフローを【確定】し【完了】の状態になったときのみ表示されます。"/>                 
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">   
              <AtcProjectItem title="案件" :value.sync="item.projectItem" :editor="editor"  :enabled="false"  tooltip="発注伝票で指定した案件が表示されます。入荷では変更できません。"/>                          
              <AtcSegment title="部門" :value.sync="item.segment" :editor="editor" :required="true" :enabled="!item.hasOrder && isEditable(item.state, item.deliveryFlag, false) && isEditable2(item,true)" tooltip="担当部門を選択します。【部門一覧】のデータから選択することができます。"/>
              <AutoComplete title="担当者" :value.sync="item.pic" :editor="editor" list="user" :required="true" :enabled="isEditable(item.state, item.deliveryFlag, false)" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>
              <ComboBox title="取引通貨" v-if="hasLicenseCurrency" :value.sync="item.currencyCode" list="currency" :required="true" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false) && isEditable2(item,true)" @changed="onChangeCurrency(item)" nullValue="" />       
              <NumericBox title="計上レート" v-if="hasLicenseCurrency" :value.sync="item.exchangeRate" :required="true" :min="0"  :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false) && isEditable2(item,true)" :decimalsInput="6" />                                   
              <NumericBox title="入荷金額" :value.sync="item.dealAmountFC" :editor="editor" :enabled="false" :decimals="$api.decimals[item.currencyCode]" tooltip="【入荷明細】に登録されている【単価】×【入荷数量】の合計金額が表示されます。"/>
              <TextBox title="税計算区分" :value="(item.counterpart ? item.counterpart.taxType : '') | taxTypes" :editor="editor" :enabled="false" tooltip="選択した仕入先に対応した【得意先一覧】の【税計算区分】の値が表示されます。"/>
              <TextBox title="登録番号" :value="(item.counterpart ? item.counterpart.invoiceNo : '')" :editor="editor" :enabled="false" tooltip="取引先マスタに設定されている適格請求書発行事業者の登録番号が表示されます。<br>発行事業者とそれ以外で【税区分】を分けると「仕入元帳(税区分集計)」で集計できます。"/>
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="入荷データを最後に更新した日時が表示されています。"/>
              <ComboBox title="ワークフロー" :value.sync="item.workflowId" :editor="editor" list="workflow_purchaseDelivery" :required="$api.perms.hasWorkflow('purchaseDelivery')" :enabled="$api.perms.hasWorkflow('purchaseDelivery') && $api.perms.isEntryStatus(item)" :nullValue="0" tooltip="入荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【入荷管理】になっているデータから選択ができます。"/>
              <TextBox title="状態" :value="$api.perms.getWorkflowStateLabel(item)" :enabled="false" tooltip="入荷データの今現在の状態が表示されており､確定や業務処理を行う事で変化します。"/>                 
            </template>
          </EditPanel>
        </template>
        <!-- 入荷明細タブ -->
        <template slot="tab1" slot-scope="{ item,editor}">
          <GrdVoucherItem :voucherNo="item.deliveryNo" :voucherType="voucherTypes.PurchaseDelivery" :showCheckBox="true" :voucherItemType="voucherTypes.PurchaseDeliveryItem"  :isBarcodeInspection="isBarcodeInspection" ref="purchaseDeliveryItems"  :comparer="(a,b)=>a.auditNo == b.auditNo">
              <template slot="menu" slot-scope="{parent}" >
                <Button class="button" @click="showBundleAddDeliveryItemDialog" caption="明細の追加" :perm="$refs.mainList.perm + '.edit'"  :disabled="(editor.owner.isAdding == false && editor.isEdit) || disabledAddItemButton(item) || item.isTransitPost || ($refs.purchaseDeliveryItems && $refs.purchaseDeliveryItems.isLoading)" icon="add" tooltip="選択した入荷に紐づく【入荷明細】の登録を行います。"/>
                <Button class="button" @click="parent.onDelete().then(()=>$refs.mainList.reloadSelected())" :perm="$refs.mainList.perm + '.edit'"   caption="明細の削除" :disabled="editor.isEdit || disabledAddItemButton(item) || parent.isLoading" icon="delete"/>              
                <Button class="button" @click="showReturnDeliveryDialog(item)"  :perm="$refs.mainList.perm + '.process'"  caption="返品処理" :disabled="editor.isEdit || disabledReturnDeliveryItemFuncButton(item) || ($refs.purchaseDeliveryItems && $refs.purchaseDeliveryItems.isLoading)" tooltip="選択した明細に対して､返品の伝票を作成します。"/>
              </template>
              <PopupEditor slot="popupEditor" slot-scope="{parent}" v-model="parent.showEditor" title="入荷明細" mode="editor" :isInsertMode="false" @closing="args=>{parent.replaceItem(args.target);$refs.mainList.reloadSelected();}">
                <PurchaseDeliveryItem slot-scope={popup} :popup="popup" :deliveryItemNo="parent.editItem ? parent.editItem.deliveryItemNo: null"/>
              </PopupEditor>                          
          </GrdVoucherItem>
        </template>
        <!-- 仕入諸掛タブ -->
        <!-- <template slot="tab2" slot-scope="{ item}">
          <GrdVoucherItem :voucherNo="item.deliveryNo" :voucherType="voucherTypes.PurchaseDelivery" :voucherItemType="voucherTypes.PurchaseCharge" />
        </template>                       -->
        <!-- 記載事項タブ -->
        <template slot="tab2" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 記載事項タブ 左側 -->
            <template slot="left">
              <TextBox title="決済条件" :value.sync="item.paymentTerm" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false) && isEditable2(item,true)" length="50" tooltip="任意で決済に関わる情報を最大50文字まで入力でき、内容を帳票に載せることができます。"/>
              <TextBox title="特記事項" :value.sync="item.remark" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="10" tooltip="任意で特記したい情報を最大200文字まで入力できます。"/>
            </template>
            <!-- 記載事項タブ 右側 -->
            <template slot="right">
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditable(item.state)" length="200" rows="12" tooltip="任意で入荷に関わる様々な情報を最大200文字まで入力できます。"/>
            </template>
          </EditPanel>
        </template>
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value.sync="item.outputReceiverName" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="担当部署名" :editor="editor" :value.sync="item.outputReceiverPICSection" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="担当者" :editor="editor" :value.sync="item.outputReceiverPIC" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="30" />
              <TextBox title="敬称" :editor="editor" :value.sync="item.outputReceiverPICHonorificTitle" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="5" />
              <TextBox title="電話番号" :editor="editor" :value.sync="item.outputReceiverTelNo" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value.sync="item.outputReceiverFaxNo" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="20" />
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <div style="display:flex;">
                <TextBox title="郵便番号" :editor="editor" :value.sync="item.outputReceiverPostalCode" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="$api.getAddress(item.outputReceiverPostalCode).then(res => item.outputReceiverAddress1 = res)" caption="住所取得" :disabled="!isEditable(item.state, item.deliveryFlag, false)  || editor.isEdit ==false" tooltip="郵便番号から住所を取得します"/>
              </div>                  
              <TextBox title="住所1" :editor="editor" :value.sync="item.outputReceiverAddress1" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="住所2" :editor="editor" :value.sync="item.outputReceiverAddress2" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="住所3" :editor="editor" :value.sync="item.outputReceiverAddress3" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
            </template>
          </EditPanel>
        </template>        
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 予備項目タブ 左側 -->
            <template slot="left">
              <TextBox title="voucher_text1" :value.sync="item.reserveText1" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text2" :value.sync="item.reserveText2" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text3" :value.sync="item.reserveText3" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text4" :value.sync="item.reserveText4" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text5" :value.sync="item.reserveText5" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <TextBox title="voucher_text6" :value.sync="item.reserveText6" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="50" />
              <AutoComplete title="voucher_list1" :value.sync="item.reserveList1" :editor="editor" list="category_31" :enabled="isEditable(item.state, item.deliveryFlag, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list2" :value.sync="item.reserveList2" :editor="editor" list="category_32" :enabled="isEditable(item.state, item.deliveryFlag, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
              <AutoComplete title="voucher_list3" :value.sync="item.reserveList3" :editor="editor" list="category_33" :enabled="isEditable(item.state, item.deliveryFlag, false)" path="/master/Category" tooltip="任意で区分を設定できます。選択項目は【区分一覧】から追加・修正が可能です。"/>
            </template>
            <!-- 予備項目タブ 右側 -->
            <template slot="right">
              <Calendar title="voucher_date1" :value.sync="item.reserveDate1" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" :deletable="true" />
              <Calendar title="voucher_date2" :value.sync="item.reserveDate2" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" :deletable="true" />
              <Calendar title="voucher_date3" :value.sync="item.reserveDate3" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" :deletable="true" />
              <TextBox title="voucher_memo1" :value.sync="item.reserveMemo1" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="2" />
              <TextBox title="voucher_memo2" :value.sync="item.reserveMemo2" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="2" />
              <TextBox title="voucher_memo3" :value.sync="item.reserveMemo3" :editor="editor" :enabled="isEditable(item.state, item.deliveryFlag, false)" length="200" rows="2" />
            </template>
          </EditPanel>
        </template>

        <!-- ワークフロータブ -->
        <template slot="tab5" slot-scope="{ item, editor }">
          <MessageList class="cx_matter_message" :item="item" :editor="editor" />
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab6" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
        <!-- 添付ファイルタブ -->
        <template slot="tab7" slot-scope="{ item, editor }">
          <ListFiles :editor="editor" title="添付ファイル" :height="300" :parentKey="item.auditName" :parentId="item.auditNo" :electronicBookMode="tenantSettings.electronicBookMode" />
        </template>
      </Editor>
      <!--  支払処理ダイアログ-->
      <ListDialog ref="deliveryPaymentDialog" title="支払処理" modelName="Delivery" :captions="['入荷番号', '支払可能額', '支払額']" :widths="[150, 130, 130,]" :showAdd="false" :showRemove="false" :exec="submitDeliveryPayment" :height="220">
        <template slot="header" slot-scope="{ editor }">
          <!-- <AtcSegment title="部門" :value.sync="dpSegment" :editor="editor" :required="true" /> -->
          <AutoComplete title="担当者" :value.sync="dpPic" :editor="editor" list="user" :required="true" />
          <AtcCounterpart title="仕入先" :value.sync="dpCounterpart" :editor="editor" :needsSupplier="true" :enabled="false" />
          <template v-if="hasLicenseCurrency">
            <AutoComplete title="請求通貨" :value.sync="dpCurrencyCode" :editor="editor" list="currency" :enabled="false" @changed="onChangeDpCurrency" />
          </template>
          <Calendar title="支払日" :value.sync="dpPaymentDate" :editor="editor" @changed="onChangeDpCurrency" />
          <AtcBankAccount title="支払口座" :value.sync="dpBankAccount" :editor="editor" :required="true" />
          <template v-if="hasLicenseCurrency">
            <NumericBox title="支払レート" :value="dpExchageRate" :editor="editor" :enabled="false" decimals="2" />
          </template>

        </template>
        <template slot="footer" slot-scope="{ editor }">
          <NumericBox title="決済金額" :value="dpSettlementAmountFC" :editor="editor" :enabled="false" decimals="2"  /> 
          <NumericBox title="手数料額" :value.sync="dpCommissionAmountFC" :editor="editor" min="0" max="9999" decimals="2" :nullValue="0" />
          <NumericBox title="口座支払額" :value="dpPaymentAmountFC" :editor="editor" :enabled="false" decimals="2" />
          <!-- <template v-if="hasLicenseCurrency">
            <ComboBox title="手数料額課税区分" :value.sync="dpCommissionTaxFlag" :editor="editor" list="commissionTaxFlag" :required="true" :showDefault="false" />
          </template> -->
         
          </template>        
        <TextBox slot="col0" slot-scope="{ item, editor }" :value="item.deliveryNo" :editor="editor" :enabled="false" />
        <NumericBox slot="col1" slot-scope="{ item, editor }" :value="item.pendingBalanceAmountFC" :editor="editor" :enabled="false" decimals="2" :nullValue="0" />
        <NumericBox slot="col2" slot-scope="{ item, editor }" :value.sync="item.writeoffAmountFC" :editor="editor" :required="true" :min="dpMin(item)" :max="dpMax(item)" decimals="2" />
      </ListDialog>
      <!-- 明細一括入力ダイアログ -->
      <ListDialog ref="bundleAddDeliveryItemDialog" title="明細一括入力" modelName="PurchaseDeliveryItem" :captions="badiCaptions" :widths="badiWidths" :exec="submitBundleAddDeliveryItem" :onCreate="onItemCreate"  :height="235" :width="1000">
        <AtcCommodity :slot="badiSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :required="true" @update:value="onChangeCommodity(item, item.commodity)" />
        <TextBox :slot="badiSlots[1]" slot-scope="{ item, editor }" :value.sync="item.commodityName" :editor="editor" :required="true" length="100" />
        <AtcSKU :slot="badiSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" @update:value="getPriceAndTaxCode(item)" />        
        <AtcConversion :slot="badiSlots[3]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.uom2" :commodity="item.commodity" :required="true" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="badiSlots[4]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" min="-99999999.999" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" :nullValue="0" @update:value="getPriceAndTaxCode(item)" />
        <NumericBox :slot="badiSlots[5]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.unitPrice" :required="!tenantSettings.noCheckPriceRequired" min="-99999999999.999999" max="99999999999.999999" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" />
        <AtcTaxCode :slot="badiSlots[6]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.taxCode" :taxType="listView.selected.counterpart.taxType"  list="taxCode" :required="true" />       

        <TextBox :slot="badiSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="badiSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText1)" />
        <TextBox :slot="badiSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="badiSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText2)" />
        <TextBox :slot="badiSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="badiSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText3)" />
        <TextBox :slot="badiSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="badiSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText4)" />
        <TextBox :slot="badiSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="badiSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText5)" />
        <TextBox :slot="badiSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="badiSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" length="50" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveText6)" />
        <TextBox :slot="badiSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" length="200" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="badiSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" length="200" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveMemo1)" />
        <TextBox :slot="badiSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" length="200" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="badiSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" length="200" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveMemo2)" />
        <TextBox :slot="badiSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" length="200" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveMemo3)" />
        <TextBox :slot="badiSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" length="200" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveMemo3)" />
        <Calendar :slot="badiSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :deletable="true" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="badiSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :deletable="true" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveDate1)" />
        <Calendar :slot="badiSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :deletable="true" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="badiSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :deletable="true" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveDate2)" />
        <Calendar :slot="badiSlots[18]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :deletable="true" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveDate3)" />
        <Calendar :slot="badiSlots[18]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :deletable="true" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveDate3)" />
        <AutoComplete :slot="badiSlots[19]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category"/>
        <AutoComplete :slot="badiSlots[19]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveList1)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[20]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[20]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveList2)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[21]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
        <AutoComplete :slot="badiSlots[21]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo"  :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="isEditable3(tenantSettings.usedTypeDetailReserveList3)" path="/master/Category" />
      </ListDialog>
      <!-- 発注伝票選択一覧ダイアログ -->
      <ListDialog ref="advancePaymentWriteoffAddDialog" title="発注伝票選択一覧" modelName="Order" :captions="['発注番号', '前払金残高', '消込金額']" :widths="[100, 100, 150]" :showAdd="false" :showRemove="false" :exec="submitAdvancePaymentWriteoffAdd" >
        <template slot="header" slot-scope="{ editor }">
          <!-- <TextBox title="仕入先" :value="apwaCounterpartName" :editor="editor" :enabled="false" /> -->
          <AtcCounterpart title="仕入先" :value.sync="apwaCounterpart" :editor="editor" :needsSupplier="true" :enabled="false" />          
        </template>
        <TextBox slot="col0" slot-scope="{ item, editor }" :value="item.orderNo" :editor="editor" :enabled="false" />
        <NumericBox slot="col1" slot-scope="{ item, editor }" :value="item.advanceAvailableAmountFC" :editor="editor" :enabled="false" :nullValue="0" decimals="3" />
        <NumericBox slot="col2" slot-scope="{ item, editor }" :value.sync="item.writeoffAmountFC" :editor="editor"  min="0" :max="item.advanceAvailableAmountFC" :nullValue="0" decimals="3" />
      </ListDialog>
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseDeliveryView extends Vue {
  public returnDelivery = Components.ReturnDelivery;
  public items: Common.PurchaseDelivery[] = new Array(0);
  public params: Common.DeliveryQuery = new Common.DeliveryQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.DeliveryImportQuery('入荷',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.DeliveryExportQuery('入荷',this.params,Common.SalesPurchaseFlags.Purchase);
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text:'状態' },
    { value: 'deliveryNo', text: '入荷番号' },
    { value: 'bookDate', text: '仕入日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'warehouse', text: '入庫倉庫' },
    { value: 'receiver', text: '納入先' },
    { value: 'deliveryDate', text: '入荷日' },
    { value: 'refNo', text: '入荷管理番号' },
    { value: 'projectItem', text: '案件' },      
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true, true]; //前払・支払情報を非表示
  public tabVisiblesOnInsert: Array<boolean> = [true, true, true, true, true, false, false, false];    
  public tenantSettings: Common.TenantSettings = null;
  public hasLicenseCurrency: boolean = false;
  public voucherTypes = Common.voucherTypes;
    public DeliveryFlags = Common.DeliveryFlags;
    
  @Prop() public deliveryNo:string;
  @Prop({default:null}) public popup: Components.PopupEditor;  
  
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public get isBarcodeInspection(){
    return (this.$api.tenantSettings.inspectionMode & Common.InspectionModes.receipt) > 0 ;
  }


  // 支払情報タブ可変表示用プロパティ
  public paymentTabCaptions = new Array();
  public paymentTabWidths = new Array();
  public paymentTabSlots = new Array();
  public paymentTabGridConfig:Common.GridConfiguration =
    new Common.GridConfiguration([
      new Common.GridItemConfiguration('状態', 120),
      new Common.GridItemConfiguration('支払伝票番号', 150),
      new Common.GridItemConfiguration('支払日', 120),
    ],
    3, // 入金日の次を可変表示項目の挿入位置に指定
    'col'
  );
  // ライセンスによって表示の切り替わる項目
  public paymentTabVariableGridItems1: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払通貨', 150),
    new Common.GridItemConfiguration('支払レート', 150)
  ];
  public paymentTabVariableGridItems2: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払金額', 150)
  ];
  public paymentTabVariableGridItems3: Common.GridItemConfiguration[] = [
    new Common.GridItemConfiguration('支払計上額', 150)
  ];

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;
    
    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);
    // 一覧表示項目の制御

    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 200),
      new Common.GridItemConfiguration('入荷番号', 120),
      new Common.GridItemConfiguration('ワークフロー', 250),      
      new Common.GridItemConfiguration('仕入日', 120),
      new Common.GridItemConfiguration('仕入先', 180),
      new Common.GridItemConfiguration('納入区分', 120),
      // new Common.GridItemConfiguration('入荷予定日', 120),
      new Common.GridItemConfiguration('入荷日', 120),
      new Common.GridItemConfiguration('入庫倉庫', 150),
      new Common.GridItemConfiguration('納入先', 150),        
      new Common.GridItemConfiguration('入荷管理番号', 150),
      new Common.GridItemConfiguration('計上区分', 100),      
      new Common.GridItemConfiguration('取引通貨', 120, this.hasLicenseCurrency),
      new Common.GridItemConfiguration('入荷金額', 120),
      new Common.GridItemConfiguration('税計算区分', 120),
      new Common.GridItemConfiguration('計上レート', 120, this.hasLicenseCurrency),      
      new Common.GridItemConfiguration('案件', 150),          
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),
      // new Common.GridItemConfiguration('支払締日', 120,false),
      // new Common.GridItemConfiguration('支払予定日', 120,false),
      // new Common.GridItemConfiguration('税抜金額', 120,false),
      // new Common.GridItemConfiguration('消費税額', 120,false),
      // new Common.GridItemConfiguration('税込金額', 120,false),
      // new Common.GridItemConfiguration('買掛金残高', 120,false),      
      // new Common.GridItemConfiguration('計上金額', 120,false),
      // new Common.GridItemConfiguration('計上税額', 120, false),
      // new Common.GridItemConfiguration('税込計上額', 120,false),  
      new Common.GridItemConfiguration('初回保存日', 120),
      new Common.GridItemConfiguration('初回保存者', 120),
      new Common.GridItemConfiguration('最終更新日', 120),
      new Common.GridItemConfiguration('最終更新者', 120),


    );
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;

    // インポート・エクスポートの制御
    this.importQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;
    // タブ表示の制御
    // this.$set(this.tabVisibles, 6, this.hasLicenseImport); // 前払金適用一覧タブ=>PurchaseInvoiceに移動
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction);
    this.$set(this.tabVisiblesOnInsert, 4, this.$api.useStockFunction);

    // 支払情報タブの表示項目制御
    this.paymentTabVariableGridItems1.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems3.forEach(item => item.IsVisible = this.hasLicenseCurrency);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems2);
    this.paymentTabVariableGridItems1 = this.paymentTabVariableGridItems1.concat(this.paymentTabVariableGridItems3);
    this.paymentTabGridConfig.setVariableItems(this.paymentTabVariableGridItems1);
    this.paymentTabCaptions = this.paymentTabGridConfig.gridCaptions;
    this.paymentTabWidths = this.paymentTabGridConfig.gridWidths;
    this.paymentTabSlots = this.paymentTabGridConfig.gridSlots;

    // 検索条件を設定する
    if(this.deliveryNo){
      this.params.deliveryNo = this.deliveryNo;
      this.params.state = null;
    }else{
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
  }

  public async onCreate(obj: Common.PurchaseDelivery) {
    const workflows = this.$api.formatter.getOptions('workflow_purchaseDelivery');
    if (workflows.length > 0) obj.workflowId = workflows[0].value;
    obj.pic = this.$api.auth.userId;
    obj.bookDate = new Date().getCalendarDate();
    obj.deliveryFlag = this.$api.useStockFunction ? Common.DeliveryFlags.Stock : Common.DeliveryFlags.Services;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
    //入荷明細タブのリロード
    (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();       
  }

  //仕入伝票へのリンク表示
  public isInvoiceVisible(item: Common.Delivery){
    return item.isTransitPost || item.state == Common.DeliveryStatus.PurchaseDeliveryCompleted;
  }
  // 状態から編集可能か判別する
  public isEditable(state: Common.DeliveryStatus, deliveryFlag:Common.DeliveryFlags, shouldCheckDeliveryFlag:boolean, isDirect:boolean = true, isArrived:boolean = false):boolean{
    
    if(shouldCheckDeliveryFlag && (deliveryFlag == Common.DeliveryFlags.Direct) == isDirect) return false;
    if(state == Common.DeliveryStatus.PurchaseDeliverySaving) return true;
    //if(isArrived && state >= Common.DeliveryStatus.PurchaseDeliverySaving && state <= Common.DeliveryStatus.PurchaseDeliveryPostWaiting) return true;
    return false;
  }
  public isEditable2(item: Common.PurchaseDelivery, isTransitPost: boolean):boolean{
  // 未着品の場合編集不可とする
    if(isTransitPost && item.isTransitPost ) return false;
  }

  // 現金口座の必須・活性を判別する
  public requiredBankAccount(item: Common.Delivery):boolean{
    return item.state == Common.DeliveryStatus.PurchaseDeliverySaving &&  item.settlement == Common.SettlementTypes.ByCash;
  }

  // 仕入先変更時に仕入先の通貨を設定する
  public onChangeSupplier(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.currencyCode = item.counterpart ? item.counterpart.currencyCode : '';
    item.onChangeCounterpart();
    this.onChangeBookDate(item, editor);
  }

  // 仕入日変更時に支払締日・支払予定日を設定する
  public onChangeBookDate(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    if(item.counterpart == null || item.bookDate == null) {
        item.closingDate = null;
        item.dueDate = null;
    } else if (item.counterpart.paymentDateType == Common.PaymentDateTypes.Monthly) {
        item.closingDate = item.counterpart.getClosingDate(item.bookDate, this.tenantSettings);
        item.dueDate = item.counterpart.getPaymentDate(item.bookDate, this.tenantSettings);
    } else {
        item.closingDate = item.bookDate;
        item.dueDate = item.counterpart.getPaymentDate(item.bookDate, this.tenantSettings);        
    }

    this.onChangeCurrency(item);
  }

  // 納入先変更時に納入先詳細を設定する
  public onChangeReceiver(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeReceiver();
  }
  // 入庫倉庫変更時に納入先詳細を設定する
  public onChangeWarehouse(item: Common.Delivery, editor: Components.Editor){
    if(editor.isEdit == false) return;
    item.onChangeWarehouse();
  }

  public onChangeDeliveryDate(item: Common.Delivery, editor: Components.Editor)
  {
    if(item.isTransitPost == false)
    {
      item.bookDate = item.deliveryDate;
      this.onChangeBookDate(item,editor);
    }
  }

  // 決済方法が買掛に変更された場合、現金口座をリセットする
  public onChangeSettlement(item: Common.Delivery){
    if(item.settlement != Common.SettlementTypes.ByCash) item.bankAccount = null;
  }

  // 支払日・通貨が変更された場合、計上レートを取得する
  public async onChangeCurrency(item: Common.Delivery){
    const query = new Common.GetExchangeRateQuery();
    query.currency = item.currencyCode;
    query.startDate = item.bookDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      rate = exchangeRate ? exchangeRate.rate : 1;
      item.exchangeRate = rate;
    });
  }
  public onChangeDeliveryFlag(item: Common.Delivery){
    if(item.deliveryFlag == Common.DeliveryFlags.Services) item.warehouse = null;
  }

  // public async getExchangeRate(currencyCode: string, startDate: Date):Promise<any>{
  //   const query = new Common.GetExchangeRateQuery();
  //   query.currency = currencyCode;
  //   query.startDate = startDate;
  //   let rate = 1;
  //   await this.$api.execute(query).then(res => {
  //     const exchangeRate = res as Common.ExchangeRate;
  //     rate = exchangeRate ? exchangeRate.rate : 1;
  //   });
  //   return rate;
  // }

  // 一覧でチェックされている入荷伝票
  public checkedDeliveries: Array<Common.Delivery>= new Array(0);
  public getCheckedDeliveries(){
    this.checkedDeliveries = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.writeoffAmountFC = 0;
        this.checkedDeliveries.push(obj);
      }
    });
  }

  // 一覧選択時に明細表示ボタンの非活化状態・入金情報・前払金適用額一覧タブを更新
  public selectedDelivery: Common.Delivery;
  public onSelectedMain(index: number, selected: Common.Delivery) {
    this.selectedDelivery = selected;
  // 一覧選択時に明細表示ボタン、部門の非活化状態確認
    this.checkItemData(selected);

    // 入金情報タブを更新
    this.totalPaymentAmountFC = 0;
    this.totalPendingAmountFC = 0;    
    this.paymentJournals = new Array(0);
    if(index >= 0) this.refreshPaymentList();

    // 前払金適用額一覧タブを更新
    this.advanceWriteoffamountFC = 0;
    this.advanceJournals = new Array(0);
    if(index >= 0) this.refreshAdvanceList();
  }

  // 支払処理用プロパティ
  public dpSegment: Common.Segment = null;
  public dpPic: string = '';
  public dpCounterpart: Common.Counterpart = null;
  public dpCurrencyCode: string = '';
  public dpPaymentDate: Date = new Date;
  public dpBankAccount: Common.BankAccount = null;
  public dpExchageRate: number = 0;
  public get dpPaymentAmountFC(): number { return this.dpSettlementAmountFC + this.dpCommissionAmountFC; };
  public dpCommissionAmountFC: number = 0;
  public dpCommissionTaxFlag: boolean = false;
  public get dpSettlementAmountFC(): number {
    if(this.checkedDeliveries.length == 0) return 0;
    return this.checkedDeliveries.map(obj => obj.writeoffAmountFC).reduce((total, value) =>(total + value));
  };
  public dpMin(delivery:any): number{
    if (delivery.pendingBalanceAmountFC > 0) return 0;
    else return delivery.pendingBalanceAmountFC;
    // if(delivery.paymentBalance == null) return 0;
    // if(delivery.paymentBalance.currentAmountFC > 0) return 0;
    // return delivery.paymentBalance.currentAmountFC;
  }
  public dpMax(delivery:any): number{
    if (delivery.pendingBalanceAmountFC < 0) return 0;
    else return delivery.pendingBalanceAmountFC;    
    // if(delivery.paymentBalance == null) return 0;
    // if(delivery.paymentBalance.currentAmountFC < 0) return 0;
    // return delivery.paymentBalance.currentAmountFC;
  }
  // 入荷日の最小値、未着品計上の場合のみ設定
  public deliveryDateMin(delivery:any): Date{
    if(!delivery.isTransitPost) return null;
    else return delivery.bookDate;
  }


  // 支払処理ダイアログの表示
  public showDeliveryPaymentDialog() {
    this.getCheckedDeliveries();

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveries.length == 0){
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> (delivery.state == Common.DeliveryStatus.PurchaseDeliverySaving)).length > 0){
      this.$api.modal.show('', '入荷伝票が未確定です。', true, null);
      return;
    }
    //if(this.checkedDeliveries.filter(delivery=> (delivery.state & (Common.DeliveryStatus.PurchaseDeliveryPostWaiting | Common.DeliveryStatus.PurchaseDeliveryCompleted)) > 0).length > 0){
    if(this.checkedDeliveries.filter(delivery=> (delivery.state & (Common.DeliveryStatus.PurchaseDeliveryCompleted)) > 0).length > 0){
      this.$api.modal.show('', '支払が完了しています。', true, null);
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> this.checkedDeliveries[0].counterpart.id != delivery.counterpart.id).length > 0){
      this.$api.modal.show('', '仕入先の異なる入荷伝票を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> this.checkedDeliveries[0].currencyCode != delivery.currencyCode).length > 0){
      this.$api.modal.show('', '取引通貨の異なる入荷伝票を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    if(this.checkedDeliveries.filter(delivery=> this.checkedDeliveries[0].segmentId != delivery.segmentId).length > 0){
      this.$api.modal.show('', '部門の異なる入荷伝票を、同じ支払伝票にまとめることはできません。', true, null);
      return;
    }
    // プロパティの初期化
    this.dpSegment = this.checkedDeliveries[0].segment; //発生部門をセット(非表示)
    this.dpPic = this.$api.auth.userId;        
    this.dpCounterpart = this.checkedDeliveries[0].counterpart;
    this.dpCurrencyCode = this.checkedDeliveries[0].currencyCode;
    this.dpPaymentDate = this.checkedDeliveries.map(delivery => delivery.dueDate).reduce((min, value) => min = (min == null || min > value) ? value : min);
    this.dpBankAccount = null;
    this.dpExchageRate = 1;
    this.dpCommissionAmountFC = 0;
    this.dpCommissionTaxFlag = true; // 販売管理では課税固定
    this.onChangeDpCurrency();

    // ダイアログの表示
    (this.$refs.deliveryPaymentDialog as Components.ListDialog).items = this.checkedDeliveries;
    (this.$refs.deliveryPaymentDialog as Components.ListDialog).showDialog();
  }

  public async onChangeDpCurrency(){
    const query = new Common.GetExchangeRateQuery();
    query.currency = this.dpCurrencyCode;
    query.startDate = this.dpPaymentDate;
    let rate = 1;
    await this.$api.execute(query).then(res => {
      const exchangeRate = res as Common.ExchangeRate;
      rate = exchangeRate ? exchangeRate.rate : 1;
      this.dpExchageRate = rate;
    });
  }

  // 支払処理の実行
  public async submitDeliveryPayment(list: Array<Common.Delivery>) {
    // クエリの設定
    var query = new Common.DeliveryPaymentQuery();
    query.segment = this.dpSegment;
    query.pic = this.dpPic;
    query.counterpart = this.dpCounterpart;
    query.currencyCode = this.dpCurrencyCode;
    query.bankAccount = this.dpBankAccount;
    query.paymentDate = this.dpPaymentDate;
    query.exchangeRate = this.dpExchageRate;
    query.commissionAmountFC = this.dpCommissionAmountFC;
    query.settlementAmountFC = this.dpSettlementAmountFC;
    query.commissionTaxFlag = this.dpCommissionTaxFlag;
    query.deliveries = list;

    // 支払処理の実行
    // this.isLoading = true;
    // await this.$api.execute(query).then(res => {
    //   // this.$router.push('/cash/WithDrawal');
    //   this.$router.push(String.format('/cash/WithDrawal?paymentNo={0}',(res as Common.Payment).paymentNo));            
    // })
    // .finally(()=>{
    //   this.isLoading = false;
    // });

    return this.$api.execute(query).then(res => {
      //リストリロード
      (this.$refs.mainList as Components.ListView).reload();
      var payment = res as Common.Payment;
      //支払明細タブのリロード
      this.refreshPaymentList();
      this.$api.modal.show('処理結果','以下の支払伝票が作成されました。',true,null,[new Common.ModalLink(payment.paymentNo, String.format('/cash/WithDrawal?paymentNo={0}',payment.paymentNo))]);
      return true;
    }).catch(()=>{return false;});            
  }

  // 明細表示ボタンの非活性判別
  public disabledShowItemButton: boolean = true;
  public  checkItemData(delivery:Common.Delivery){
    this.disabledShowItemButton = true;
    
    this.isLoading = true;
    var query = new Common.GetDeliveryItemQuery();
    query.deliveryNo = delivery.deliveryNo;
    this.$api.execute(query).then(res => {
      this.disabledShowItemButton = !res.hasItem;
      delivery.hasOrder = res.hasOrder;
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseDelivery){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseDelivery, sourceNo : item.deliveryNo},this.$el);
  }
  // 入荷明細一覧を表示
  public showPurchaseDeliveryItem() {
    let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?deliveryNo={0}', this.selectedDelivery.deliveryNo));
    window.open(routeData.href, '_blank');
  }

  // 明細一括入力ボタンの非活性判別
  public disabledAddItemButton(delivery:Common.PurchaseDelivery):boolean{
    return delivery.state != Common.DeliveryStatus.PurchaseDeliverySaving;
  }

  // 返品処理ボタンの非活性判別
  public disabledReturnDeliveryItemFuncButton(delivery:Common.SalesDelivery){
    return delivery.state != Common.DeliveryStatus.PurchaseDeliveryCompleted;
  }

  // 明細一括入力ダイアログ用プロパティ
  public badiCaptions = new Array();
  public badiWidths = new Array();
  public badiSlots = new Array();
  public badiGridConfig:Common.GridConfiguration = null;
  // 明細一括入力ダイアログを表示
  public showBundleAddDeliveryItemDialog() {
    const selectedDelivery = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;    

    if(selectedDelivery.deliveryFlag == Common.DeliveryFlags.Direct) {
      this.$api.modal.show('', '直送の入荷伝票には明細を追加できません。', true, null);
      return;
    }
      // 新規の場合にチェック
    if(selectedDelivery.counterpart == null){
      this.$api.modal.show('', '仕入先を指定してください。', true, null);
      return ;
    }
    // 明細の予備項目表示の可変対応
    this.badiGridConfig = new Common.GridConfiguration([],0,'col');
    this.badiGridConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 250),
      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('SKU', 200, this.$api.useStockFunction),
      new Common.GridItemConfiguration('単位', 120),
      new Common.GridItemConfiguration('入荷数量', 130),
      new Common.GridItemConfiguration('単価', 130),
      new Common.GridItemConfiguration('税区分', 120),      
    );
    this.badiGridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,true,false,false,true));

    this.badiCaptions =this.badiGridConfig.gridCaptions;
    this.badiWidths = this.badiGridConfig.gridWidths;
    this.badiSlots = this.badiGridConfig.gridSlots;

    // ダイアログの表示
    var items = new Array();
    var instance = new Common.PurchaseDeliveryItem();
    instance.taxCode = selectedDelivery.counterpart.taxCode;
    items.push(instance);
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).items = items;
    (this.$refs.bundleAddDeliveryItemDialog as Components.ListDialog).showDialog();
  }

  // 商品変更時に商品名・単価・税区分・予備項目を設定する
  public onChangeCommodity(item:Common.PurchaseDeliveryItem, commodity:Common.Commodity){
    item.onChangeCommodity(this.tenantSettings);
    this.getPriceAndTaxCode(item);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseDeliveryItem){
    this.isLoading = true;
    this.$api.execute(new Common.DeliveryGetItemPriceQuery(this.selectedDelivery, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  //行追加時に税区分の初期値を設定
  public async onItemCreate(obj:Common.DeliveryItem){
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.Delivery;
    obj.taxCode = parent.counterpart.taxCode;
    return Promise.resolve(obj);
  }

  public submitBundleAddDeliveryItemRun(){
    const items = (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).items;
    if(items.length > 0) this.submitBundleAddDeliveryItem(items);
  }
  // 明細一括入力の実行
  public async submitBundleAddDeliveryItem(list: Array<Common.DeliveryItem>) {
    const parent = (this.$refs.mainList as Components.ListView).selected as Common.SalesDelivery;
    var items = new Array();
    for(var obj of list){
      obj.delivery = parent;
      obj.segment = parent.segment;
      obj.warehouse = parent.warehouse;
      items.push(obj);
    }
    //新規追加時は明細を一時的に保持する
    if((this.$refs.mainList as Components.ListView).isInsertMode){
     (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).mergeItems(items);
      return true;
    }
    var query = new Common.BundleAddDeliveryItemQuery(Common.SalesPurchaseFlags.Purchase);
    query.deliveryItems = items;
    // await this.$api.execute(query).then(res => {
    //   this.$router.push(String.format('/purchase/PurchaseDeliveryItem?deliveryNo={0}', this.selectedDelivery.deliveryNo));
    // });
    return this.$api.execute(query).then(res => {
      //入荷金額が更新されるのでリストを更新する
       (this.$refs.mainList as Components.ListView).onSubmit(res).finally(()=>{
        //入荷明細タブのリロード
        (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).onVoucherNoChanged();       
        //事後アクションダイアログを表示するためコメントアウト  
        //this.$api.modal.show('処理結果','処理が完了しました。',true,null);
      });
      return true;
    }).catch(()=>{return false;});        
  }

  //明細一括入力ダイアログの予備項目の活性・非活性を切り替える
  public isEditable3(usedType: Common.UsedTypes){
    //商品識別情報,在庫識別情報,入出荷メモは活性。それ以外は非活性
        if(usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.StockAttribute || usedType == Common.UsedTypes.DeliveryMemo)  return true; else return false;
  }  

  // 入金情報タブ更新用プロパティ
  public isLoading:boolean = false;
  public totalPaymentAmountFC:number = 0;
  public totalPaymentAmount: number = 0;
  public totalPendingAmountFC:number = 0;    
  public paymentJournals: Common.TransferJournal[]= new Array(0);

  // 支払情報タブを更新
  public refreshPaymentList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;
    var totalWriteoffAmount = 0;
    var totalWriteoffPendingAmountFC = 0;        
    // クエリの設定
    var query = new Common.PaymentJournalQuery();
    query.voucherNo = this.selectedDelivery.deliveryNo;
    query.isSend = true;

    // サーバーから支払情報を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.paymentJournals = res.result;
        this.paymentJournals.forEach((obj, index) => {
          if (obj.isPosted) {
            totalWriteoffAmountFC += obj.amountFC;
            totalWriteoffAmount += obj.creditAmount;
            obj.state = Common.PaymentStatus.PaymentCompleted;
          } else {
            totalWriteoffPendingAmountFC += obj.amountFC;
            obj.state = Common.PaymentStatus.PaymentPostWaiting;            
          }
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.totalPaymentAmountFC = totalWriteoffAmountFC;
      this.totalPaymentAmount = totalWriteoffAmount;
      this.totalPendingAmountFC = totalWriteoffPendingAmountFC;            
    });
  }

  // 支払一覧へ遷移する
  public onPaymentNoClick(paymentNo: string){
    this.$router.push(String.format('/cash/Withdrawal?paymentNo={0}',paymentNo));
  }
  public onOrderNoClick(orderNo: string){
    this.$router.push(String.format('/purchase/PurchaseOrder?orderNo={0}',orderNo));
  }
  // 前払金適用額一覧タブ更新用プロパティ
  public advanceWriteoffamountFC:number = 0;
  public advanceJournals: Common.TransferJournal[]= new Array(0);

  // 前払金適用額一覧タブを更新
  public refreshAdvanceList(){
    this.isLoading = true;
    var totalWriteoffAmountFC = 0;

    var query = new Common.AdvancePaymentJouralQuery();
    query.delivery = this.selectedDelivery;

    // サーバーから前払金適用額を取得する
    this.$api.execute(query).then(res => {
      if((this.$refs.mainList as Components.ListView).isInsertMode == false){
        res = res as Common.LoadResult;
        this.advanceJournals = res.result;
        this.advanceJournals.forEach((obj, index) => {
          totalWriteoffAmountFC += obj.amountFC;
        });
      }
    }).finally(()=>{
      this.isLoading = false;
      this.advanceWriteoffamountFC = totalWriteoffAmountFC;
    });
  }

  // 発注伝票選択一覧ダイアログ用プロパティ
  public apwaCounterpartName: string = '';
  public apwaCounterpart: Common.Counterpart = null;
  // 発注伝票選択一覧ダイアログの表示
  public showAdvancePaymentWriteoffAddDialog() {
    if (this.selectedDelivery != null)
    {
      this.apwaCounterpartName = this.selectedDelivery.counterpart.name;
      this.apwaCounterpart = this.selectedDelivery.counterpart;
      this.isLoading = true;
      this.$api.execute(new Common.AdvanceBalanceQuery(this.selectedDelivery.counterpart.id,0)).then(res => {
        (this.$refs.advancePaymentWriteoffAddDialog as Components.ListDialog).items = (res as Common.LoadResult).result ;
        (this.$refs.advancePaymentWriteoffAddDialog as Components.ListDialog).showDialog();
      })
      .finally(()=>{
        this.isLoading = false;
      });
    }
  }
  // チェックされている発注明細を取得する
  public selectedSalesDeliveryItems(){
    return (this.$refs.purchaseDeliveryItems as Components.GrdVoucherItem).selectedItems;
  }
  // 返品処理ダイアログの表示
  public showReturnDeliveryDialog(delivery:Common.PurchaseDelivery){
    let componentClass = Vue.extend(this.returnDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          parentDelivery: delivery,
          checkedDeliveryItems: this.selectedSalesDeliveryItems(),
          salesPurchaseFlag: Common.SalesPurchaseFlags.Purchase,
          parentMainList: this.$refs.mainList,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }

  // 前払金追加の実行
  public async submitAdvancePaymentWriteoffAdd(list: Array<Common.Order>) {
    // クエリの設定
    var query =new Common.AdvancePaymentWriteoffAddQuery();
    query.delivery = this.selectedDelivery;
    query.orders = list;

    // 前払金追加の実行
    this.isLoading = true;
    await this.$api.execute(query).then(res => {
      // 前払金適用額一覧を更新
      this.refreshAdvanceList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前払金削除の実行
  public submitAdvancePaymentWriteoffDelete() {
    // 前払金消込が0件の場合は、何もしない
    var journals:Array<any> = (this.$refs.advanceListBox as Components.Grid).items;
    if(journals.length == 0) return;

    // 選択している前払金消込の取得
    var selectedId = (this.$refs.advanceListBox as Components.Grid).selectedId;
    var journal = journals[selectedId];

    // クエリの設定
    var query = new Common.AdvancePaymentWriteoffDeleteQuery();
    query.transferJournal = journal;

    // 前払金削除の実行
    this.isLoading = true;
    this.$api.execute(query).then(res =>{
      // 前払金適用額一覧を更新
      this.refreshAdvanceList();
    })
    .finally(()=>{
      this.isLoading = false;
    });
  }

  // 前受金追加・削除ボタン活性制御
  public disabledAdvanceWriteoff():boolean{
    return this.isLoading || this.selectedDelivery.state != Common.DeliveryStatus.PurchaseDeliverySaving;
  }
}
</script>

<style lang="scss">
.cx_advance_buttons {
  // flex: 1;
  margin: 0 0 5px 0;
  display: flex;
  justify-content: flex-end;

  button {
    font-size: 12px;
    margin: 0px 0px 0px 5px;
    padding: 4px 8px 4px 6px;
  }
}
// .cx_link_item {
//   &:hover {
//     font-weight: bolder;
//     color: #007de4 !important; 
//   }
// }
</style>